import { render, staticRenderFns } from "./BusinessOwnerOnboaringComponent.vue?vue&type=template&id=2497de06&scoped=true"
import script from "./BusinessOwnerOnboaringComponent.vue?vue&type=script&lang=js"
export * from "./BusinessOwnerOnboaringComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2497de06",
  null
  
)

export default component.exports